const STORAGE_KEY = "saca_location";
const DEFAULT_COUNTRY_FALLBACK = (process.env.REACT_APP_DEFAULT_COUNTRY_CODE || "NGA").trim().toUpperCase();

export interface LocationData {
    countryCode: string;
    countryName: string;
    state: string;
    city: string;
    currencyCode?: string;
    [key: string]: unknown;
}

const ISO2_TO_ISO3: Record<string, string> = {
    AF: "AFG",
    AX: "ALA",
    AL: "ALB",
    DZ: "DZA",
    AS: "ASM",
    AD: "AND",
    AO: "AGO",
    AI: "AIA",
    AQ: "ATA",
    AG: "ATG",
    AR: "ARG",
    AM: "ARM",
    AW: "ABW",
    AU: "AUS",
    AT: "AUT",
    AZ: "AZE",
    BS: "BHS",
    BH: "BHR",
    BD: "BGD",
    BB: "BRB",
    BY: "BLR",
    BE: "BEL",
    BZ: "BLZ",
    BJ: "BEN",
    BM: "BMU",
    BT: "BTN",
    BO: "BOL",
    BQ: "BES",
    BA: "BIH",
    BW: "BWA",
    BV: "BVT",
    BR: "BRA",
    IO: "IOT",
    BN: "BRN",
    BG: "BGR",
    BF: "BFA",
    BI: "BDI",
    KH: "KHM",
    CM: "CMR",
    CA: "CAN",
    CV: "CPV",
    KY: "CYM",
    CF: "CAF",
    TD: "TCD",
    CL: "CHL",
    CN: "CHN",
    CX: "CXR",
    CC: "CCK",
    CO: "COL",
    KM: "COM",
    CG: "COG",
    CD: "COD",
    CK: "COK",
    CR: "CRI",
    CI: "CIV",
    HR: "HRV",
    CU: "CUB",
    CW: "CUW",
    CY: "CYP",
    CZ: "CZE",
    DK: "DNK",
    DJ: "DJI",
    DM: "DMA",
    DO: "DOM",
    EC: "ECU",
    EG: "EGY",
    SV: "SLV",
    GQ: "GNQ",
    ER: "ERI",
    EE: "EST",
    SZ: "SWZ",
    ET: "ETH",
    FK: "FLK",
    FO: "FRO",
    FJ: "FJI",
    FI: "FIN",
    FR: "FRA",
    GF: "GUF",
    PF: "PYF",
    TF: "ATF",
    GA: "GAB",
    GM: "GMB",
    GE: "GEO",
    DE: "DEU",
    GH: "GHA",
    GI: "GIB",
    GR: "GRC",
    GL: "GRL",
    GD: "GRD",
    GP: "GLP",
    GU: "GUM",
    GT: "GTM",
    GG: "GGY",
    GN: "GIN",
    GW: "GNB",
    GY: "GUY",
    HT: "HTI",
    HM: "HMD",
    VA: "VAT",
    HN: "HND",
    HK: "HKG",
    HU: "HUN",
    IS: "ISL",
    IN: "IND",
    ID: "IDN",
    IR: "IRN",
    IQ: "IRQ",
    IE: "IRL",
    IM: "IMN",
    IL: "ISR",
    IT: "ITA",
    JM: "JAM",
    JP: "JPN",
    JE: "JEY",
    JO: "JOR",
    KZ: "KAZ",
    KE: "KEN",
    KI: "KIR",
    KP: "PRK",
    KR: "KOR",
    KW: "KWT",
    KG: "KGZ",
    LA: "LAO",
    LV: "LVA",
    LB: "LBN",
    LS: "LSO",
    LR: "LBR",
    LY: "LBY",
    LI: "LIE",
    LT: "LTU",
    LU: "LUX",
    MO: "MAC",
    MG: "MDG",
    MW: "MWI",
    MY: "MYS",
    MV: "MDV",
    ML: "MLI",
    MT: "MLT",
    MH: "MHL",
    MQ: "MTQ",
    MR: "MRT",
    MU: "MUS",
    YT: "MYT",
    MX: "MEX",
    FM: "FSM",
    MD: "MDA",
    MC: "MCO",
    MN: "MNG",
    ME: "MNE",
    MS: "MSR",
    MA: "MAR",
    MZ: "MOZ",
    MM: "MMR",
    NA: "NAM",
    NR: "NRU",
    NP: "NPL",
    NL: "NLD",
    AN: "ANT",
    NC: "NCL",
    NZ: "NZL",
    NI: "NIC",
    NE: "NER",
    NG: "NGA",
    NU: "NIU",
    NF: "NFK",
    MK: "MKD",
    MP: "MNP",
    NO: "NOR",
    OM: "OMN",
    PK: "PAK",
    PW: "PLW",
    PS: "PSE",
    PA: "PAN",
    PG: "PNG",
    PY: "PRY",
    PE: "PER",
    PH: "PHL",
    PN: "PCN",
    PL: "POL",
    PT: "PRT",
    PR: "PRI",
    QA: "QAT",
    RE: "REU",
    RO: "ROU",
    RU: "RUS",
    RW: "RWA",
    BL: "BLM",
    SH: "SHN",
    KN: "KNA",
    LC: "LCA",
    MF: "MAF",
    PM: "SPM",
    VC: "VCT",
    WS: "WSM",
    SM: "SMR",
    ST: "STP",
    SA: "SAU",
    SN: "SEN",
    RS: "SRB",
    SC: "SYC",
    SL: "SLE",
    SG: "SGP",
    SX: "SXM",
    SK: "SVK",
    SI: "SVN",
    SB: "SLB",
    SO: "SOM",
    ZA: "ZAF",
    GS: "SGS",
    SS: "SSD",
    ES: "ESP",
    LK: "LKA",
    SD: "SDN",
    SR: "SUR",
    SJ: "SJM",
    SE: "SWE",
    CH: "CHE",
    SY: "SYR",
    TW: "TWN",
    TJ: "TJK",
    TZ: "TZA",
    TH: "THA",
    TL: "TLS",
    TG: "TGO",
    TK: "TKL",
    TO: "TON",
    TT: "TTO",
    TN: "TUN",
    TR: "TUR",
    TM: "TKM",
    TC: "TCA",
    TV: "TUV",
    UG: "UGA",
    UA: "UKR",
    AE: "ARE",
    GB: "GBR",
    US: "USA",
    UM: "UMI",
    UY: "URY",
    UZ: "UZB",
    VU: "VUT",
    VE: "VEN",
    VN: "VNM",
    VG: "VGB",
    VI: "VIR",
    WF: "WLF",
    EH: "ESH",
    YE: "YEM",
    ZM: "ZMB",
    ZW: "ZWE",
};

const ISO3_TO_COUNTRY_NAME: Record<string, string> = {
    GBR: "United Kingdom",
    NGA: "Nigeria",
    USA: "United States",
    CAN: "Canada",
    AUS: "Australia",
    FRA: "France",
    DEU: "Germany",
    IND: "India",
    CHN: "China",
    JPN: "Japan",
    BRA: "Brazil",
    RUS: "Russia",
    MEX: "Mexico",
    ESP: "Spain",
    ITA: "Italy",
    ZAF: "South Africa",
    KEN: "Kenya",
    GHA: "Ghana",
    EGY: "Egypt",
    MAR: "Morocco",
    // Add more as needed - this is a basic set for common countries
};

export const toIso3 = (code: string | undefined | null): string => {
    if (!code || typeof code !== "string") {
        return "";
    }

    const normalized = code.trim().toUpperCase();
    if (normalized.length === 3) {
        return normalized;
    }

    if (normalized.length === 2) {
        const iso3 = ISO2_TO_ISO3[normalized];
        if (iso3) {
            return iso3;
        }
    }

    return normalized;
};

export const getCountryNameFromIso3 = (iso3Code: string | undefined | null): string => {
    if (!iso3Code || typeof iso3Code !== "string") {
        return "";
    }
    const normalized = iso3Code.trim().toUpperCase();
    return ISO3_TO_COUNTRY_NAME[normalized] || "";
};

export const defaultLocation: LocationData = (() => {
    const iso3 = toIso3(DEFAULT_COUNTRY_FALLBACK) || "NGA";
    const name = getCountryNameFromIso3(iso3) || "Nigeria";

    return {
        countryCode: iso3,
        countryName: name,
        state: "",
        city: "",
    };
})();

export const normalizeLocationPayload = (location: unknown = {}): LocationData => {
    const loc = (location && typeof location === 'object' ? location : {}) as Record<string, unknown>;
    const rawCode =
        (loc.countryCode as string) ||
        (loc.country_code as string) ||
        defaultLocation.countryCode;
    const countryCode = toIso3(rawCode) || defaultLocation.countryCode;

    return {
        ...defaultLocation,
        ...loc,
        countryCode,
    };
};

export const getStoredLocation = (): LocationData => {
    if (typeof globalThis === "undefined") {
        return { ...defaultLocation };
    }

    try {
        const raw = globalThis.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return { ...defaultLocation };
        }

        const parsed = JSON.parse(raw);
        const normalized = normalizeLocationPayload(parsed);

        // Check for inconsistent country code/name data
        if (normalized.countryCode && normalized.countryName) {
            const expectedName = getCountryNameFromIso3(normalized.countryCode);
            if (expectedName && expectedName !== normalized.countryName) {
                // Fix the country name to match the country code
                normalized.countryName = expectedName;
                globalThis.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
            }
        } else if (normalized.countryCode && !normalized.countryName) {
            // Add missing country name
            const resolvedName = getCountryNameFromIso3(normalized.countryCode);
            if (resolvedName) {
                normalized.countryName = resolvedName;
                globalThis.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
            }
        }

        if (
            parsed &&
            typeof parsed === "object" &&
            parsed.countryCode !== normalized.countryCode
        ) {
            globalThis.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
        }

        return normalized;
    } catch (_error) {
        return { ...defaultLocation };
    }
};

export const saveLocation = (location: LocationData) => {
    if (typeof globalThis === "undefined") {
        return;
    }

    const payload = normalizeLocationPayload(location);
    globalThis.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const clearStoredLocation = () => {
    if (typeof globalThis === "undefined") {
        return;
    }

    globalThis.localStorage.removeItem(STORAGE_KEY);
};

// Debug utility - can be called from browser console
export const resetLocationData = () => {
    if (typeof globalThis === "undefined") {
        return;
    }

    globalThis.localStorage.removeItem(STORAGE_KEY);
    globalThis.location.reload();
};

const locationStorage = { defaultLocation, toIso3, normalizeLocationPayload, getCountryNameFromIso3 };
export default locationStorage;
